import {
    FETCH_POPUP_DATA,
    FETCH_SLIDER_DATA,
    FETCH_INFORMASI_CARDS,
    FETCH_LAYANAN_UTAMA,
    FETCH_PANDUAN_LAYANAN,
    FETCH_LAYANAN_PENUNJANG,
    FETCH_BERITA_TERKINI,
    FETCH_AGENDA_TERKINI,
    FETCH_DOKUMENTASI_KEGIATAN,
    FETCH_JEJARING_INSTANSI
} from './types';

import {
    popupData,
    sliderData,
    informasiCards,
    layananUtama,
    panduanLayanan,
    layananPenunjang,
    agendaTerkini,
    beritaTerkini,
    dokumentasiKegiatan,
    jejaringInstansi
} from '../../data/dummyData';

export const fetchPopupData = () => dispatch => {
    dispatch({
        type: FETCH_POPUP_DATA,
        payload: popupData
    });
};

export const fetchSliderData = () => dispatch => {
    dispatch({
        type: FETCH_SLIDER_DATA,
        payload: sliderData
    });
};

export const fetchInformasiCards = () => dispatch => {
    dispatch({
        type: FETCH_INFORMASI_CARDS,
        payload: informasiCards
    });
};

export const fetchLayananUtama = () => dispatch => {
    dispatch({
        type: FETCH_LAYANAN_UTAMA,
        payload: layananUtama
    });
};

export const fetchPanduanLayanan = () => dispatch => {
    dispatch({
        type: FETCH_PANDUAN_LAYANAN,
        payload: panduanLayanan
    });
};

export const fetchLayananPenunjang = () => dispatch => {
    dispatch({
        type: FETCH_LAYANAN_PENUNJANG,
        payload: layananPenunjang
    });
};

export const fetchAgendaTerkini = () => dispatch => {
    dispatch({
        type: FETCH_AGENDA_TERKINI,
        payload: agendaTerkini
    });
};

export const fetchBeritaTerkini = () => dispatch => {
    dispatch({
        type: FETCH_BERITA_TERKINI,
        payload: beritaTerkini
    });
};

export const fetchDokumentasiKegiatan = () => dispatch => {
    dispatch({
        type: FETCH_DOKUMENTASI_KEGIATAN,
        payload: dokumentasiKegiatan
    });
};

export const fetchJejaringInstansi = () => dispatch => {
    dispatch({
        type: FETCH_JEJARING_INSTANSI,
        payload: jejaringInstansi
    });
};

export const fetchAllData = () => dispatch => {
    dispatch(fetchPopupData());
    dispatch(fetchSliderData());
    dispatch(fetchInformasiCards());
    dispatch(fetchLayananUtama());
    dispatch(fetchPanduanLayanan());
    dispatch(fetchLayananPenunjang());
    dispatch(fetchBeritaTerkini());
    dispatch(fetchAgendaTerkini());
    dispatch(fetchDokumentasiKegiatan());
    dispatch(fetchJejaringInstansi());
};